<template>
  <ui-select
    v-model="form.workspaceId"
    :items="workspacesList"
    :label="label || `${t('Workspace')}*`"
    :label-help="labelHelpText"
    item-text="name"
    item-value="id"
    :return-object="false"
    :disabled="disabled"
    max-width-calc
    :hide-details="2"
    :dialog-reposition-param="dialogRepositionParam"
    :attach="attach"
    :multiple="multiple"
    :chips="chips"
    :multi-line="multiLine"
    :placeholder="placeholder"
    @change="onChangeWorkspace"
  ></ui-select>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';

defineProps<{
  form: { workspaceId: string | string[] };
  placeholder?: string;
  multiple?: boolean;
  chips?: boolean;
  multiLine?: boolean;
  label?: string;
  workspacesList: Array<{ id: string; name: string }>;
  selectOnlyPrivateWorkspaces?: boolean;
  labelHelpText?: string;
  disabled?: boolean;
  dialogRepositionParam?: string;
  attach?: string | boolean | Element;
}>();

const emit = defineEmits<{
  'change-workspace': [event: unknown];
}>();

const { t } = useI18n();

const onChangeWorkspace = (event: unknown) => {
  emit('change-workspace', event);
};
</script>
